import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import MedstationDoctors from '@/assets/medstation_doctors.svg';
import { styles } from './styles';
import Button from '../button/Button';

interface EmptyStateProps {
  title: string;
  description: string;
  isHidden: boolean;
  buttonTitle: string;
  buttonAction: () => void;
}

const EmptyState = ({
  title,
  description,
  isHidden,
  buttonTitle,
  buttonAction,
}: EmptyStateProps) => {
  if (isHidden) return null;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={styles.overlay}>
      <Box
        sx={{
          ...styles.container,
          gap: isSmallScreen ? 1 : 2,
          maxWidth: isSmallScreen ? '90%' : '100%',
          minWidth: '312px',
          minHeight: '156px',
          padding: isSmallScreen ? '1rem' : '2rem',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={MedstationDoctors}
            alt="MedstationDoctors"
            style={{
              maxWidth: isSmallScreen ? '80%' : '100%',
              maxHeight: isSmallScreen ? '200px' : 'auto',
            }}
          />
        </Box>

        <Typography
          sx={{
            ...styles.title,
            fontSize: isSmallScreen ? '1.4rem' : '1.8rem',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            ...styles.description,
            fontSize: isSmallScreen ? '1.2rem' : '1.6rem',
          }}
        >
          {description}
        </Typography>

        <Button
          title={buttonTitle}
          onlyText={false}
          outlined={false}
          color={'generic'}
          width={isSmallScreen ? '100%' : '280px'}
          height={'40px'}
          onClick={buttonAction}
          disable={false}
          loading={false}
        />
      </Box>
    </Box>
  );
};

export default EmptyState;
